module.exports = __webpack_public_path__ + "img/badge-list-thumb-075.7fff918f.png";